import { ReactElement } from "react";
import { appContext } from "../../../AppContext";
import { MenuItemKey } from "./MenuItemKey";
import { SerendieSymbol } from "@serendie/symbols";
import OntologyIcon from "../../Icons/OntologyIcon";
import PackageIcon from "../../Icons/PackageIcon";
import JigsawIcon from "../../Icons/JigsawIcon";
import JigsawPieceIcon from "../../Icons/JigsawPieceIcon";
import CustomViewIcon from "../../Icons/CustomViewIcon";

export class Menu
{
    public items = new Array<IMenuItem>();

    constructor()
    {
        const labels = appContext().labels;
        const localStorage = appContext().localStorageProvider;
        const rights = localStorage.getUserDetails().userRights;

        if (rights == null)
        {
            return;
        }

        this.items = [
            {
                id: MenuItemKey.Admin,
                label: labels.HubMenuAdminPortal,
                link: () => null,
                permissions: (rights && rights.ADMINPORTAL && Object.keys(rights.ADMINPORTAL).length > 0),
                icon: '/images/AdminPortal.svg',
                children: [
                    {
                        id: MenuItemKey.Admin_Home,
                        label: labels.Platform_Home_MenuTitle,
                        link: () => "/admin/home",
                        permissions: localStorage.hasRight('ADMINPORTAL.Home.Landing'),
                        icon: <SerendieSymbol name='home' />,
                        children: [],
                    },
                    {
                        id: MenuItemKey.Admin_Platform,
                        label: labels.Platform_Setup_MenuTitle,
                        link: () => null,
                        permissions: !!(rights && rights.ADMINPORTAL),
                        icon: <SerendieSymbol name='hard-drive' />,
                        children: [
                            {
                                id: MenuItemKey.Admin_Platform_SystemOntologies,
                                label: labels.Platform_SystemOntologies_MenuTitle,
                                link: () => "/admin/ontologies",
                                permissions: localStorage.hasRight('ADMINPORTAL.Ontologies.Setup'),
                                children: [],
                                icon: <OntologyIcon />,
                            },
                            {
                                id: MenuItemKey.Admin_Platform_Packages,
                                label: labels.Platform_Packages_MenuTitle,
                                link: () => "/admin/packages",
                                permissions: localStorage.hasRight('ADMINPORTAL.Packages.Setup'),
                                children: [],
                                icon: <PackageIcon />,
                            },
                            {
                                id: MenuItemKey.Admin_Platform_Solutions,
                                label: labels.Platform_Solutions_MenuTitle,
                                link: () => "/admin/solutions",
                                permissions: localStorage.hasRight('ADMINPORTAL.Solutions.Setup'),
                                children: [],
                                icon: <JigsawIcon />,
                            },
                            {
                                id: MenuItemKey.Admin_Platform_Tenancies,
                                label: labels.Platform_Tenancies_MenuTitle,
                                link: () => "/admin/tenancies",
                                permissions: localStorage.hasRight('ADMINPORTAL.Tenancies.Setup'),
                                children: [],
                                icon: <SerendieSymbol name='key' />,
                            },
                            {
                                id: MenuItemKey.Admin_Platform_Files,
                                label: labels.Platform_Files_MenuTitle,
                                link: () => "/filemgmt/common",
                                permissions: localStorage.hasRight('ADMINPORTAL.FileManagement.Setup'),
                                children: [],
                                icon: <SerendieSymbol name='file-upload' />,
                            },
                        ],
                    },
                    {
                        id: MenuItemKey.Admin_Tenancy,
                        label: labels.Platform_Tenancy_MenuTitle,
                        link: () => null,
                        permissions: !!(rights && rights.ADMINPORTAL),
                        icon: <SerendieSymbol name='key' />,
                        children: [
                            {
                                id: MenuItemKey.Admin_Tenancy_IdentityProviders,
                                label: labels.Platform_IdentityProviders_MenuTitle,
                                link: () => "/security-identity-providers",
                                permissions: localStorage.hasRight("ADMINPORTAL.IdentityProviders.Setup"),
                                children: [],
                                icon: <SerendieSymbol name='login' />,
                            },
                            {
                                id: MenuItemKey.Admin_Tenancy_Roles,
                                label: labels.Platform_Roles_MenuTitle,
                                link: () => "/security-roles",
                                permissions: localStorage.hasRight("ADMINPORTAL.Roles.Setup"),
                                children: [],
                                icon: <SerendieSymbol name='apps-circle' />,
                            },
                            {
                                id: MenuItemKey.Admin_Tenancy_Users,
                                label: labels.Platform_Users_MenuTitle,
                                link: () => "/security-users",
                                permissions: localStorage.hasRight("ADMINPORTAL.Users.Setup"),
                                children: [],
                                icon: <SerendieSymbol name='user' />,
                            },
                            {
                                id: MenuItemKey.Admin_Tenancy_Delegates,
                                label: labels.Platform_Delegates_MenuTitle,
                                link: () => "/admin/delegates/create",
                                permissions: localStorage.hasRight("ADMINPORTAL.Delegates.Setup"),
                                children: [],
                                icon: <SerendieSymbol name='users' />,
                            },
                            {
                                id: MenuItemKey.Admin_Tenancy_SolutionEnablement,
                                label: labels.Platform_SolutionEnablement_MenuTitle,
                                link: () => "/admin/solutions/enablement",
                                permissions: localStorage.hasRight("ADMINPORTAL.SolutionEnablement.Setup"),
                                children: [],
                                icon: <JigsawPieceIcon />,
                            },
                        ],
                    },
                    {
                        id: MenuItemKey.Admin_DataExchange,
                        label: labels.Platform_DataExchange_MenuTitle,
                        link: () => null,
                        permissions: !!(rights && rights.ADMINPORTAL),
                        icon: <SerendieSymbol name='copy' />,
                        children: [
                            {
                                id: MenuItemKey.Admin_DataExchange_Credentials,
                                label: labels.Platform_DataCredentials_MenuTitle,
                                link: () => "/admin/data-hub-credentials",
                                permissions: localStorage.hasRight('ADMINPORTAL.DataCredentials.Setup'),
                                children: [],
                                icon: <SerendieSymbol name='check-shield' />,
                            },
                            {
                                id: MenuItemKey.Admin_DataExchange_Publishers,
                                label: labels.Platform_DataPublishers_MenuTitle,
                                link: () => "/admin/data-hub-publishers",
                                permissions: localStorage.hasRight('ADMINPORTAL.DataPublishers.Setup'),
                                children: [],
                                icon: <SerendieSymbol name='arrow-left-circle' />,
                            },
                        ]
                    },
                    {
                        id: MenuItemKey.Admin_DataModel,
                        label: labels.Platform_DataModel_MenuTitle,
                        link: () => null,
                        permissions: !!(rights && rights.ADMINPORTAL && rights.ADMINPORTAL.PortfolioSetup && (rights.ADMINPORTAL.PortfolioSetup.indexOf("Spaces") > -1 || rights.ADMINPORTAL.PortfolioSetup.indexOf("Spaces/*") > -1)),
                        icon: <SerendieSymbol name='data' />,
                        children: [
                            {
                                id: MenuItemKey.Admin_DataModel_TenancyOntologies,
                                label: labels.Platform_TenancyOntologies_MenuTitle,
                                link: () => "/admin/ontologies",
                                permissions: localStorage.hasRight('ADMINPORTAL.CustomerOntologies.Setup'),
                                children: [],
                                icon: <OntologyIcon />,
                            },
                            {
                                id: MenuItemKey.Admin_DataModel_Relationships,
                                label: labels.Platform_Relationships_MenuTitle,
                                link: () => "/admin/relationships",
                                permissions: localStorage.hasRight('ADMINPORTAL.Relationships.Setup'),
                                children: [],
                                icon: <SerendieSymbol name='share-alt' />,
                            },
                        ],
                    },
                    {
                        id: MenuItemKey.Admin_AssetsAndProcesses,
                        label: labels.Platform_Configuration_MenuTitle,
                        link: () => null,
                        permissions: !!(rights && rights.ADMINPORTAL),
                        icon: <SerendieSymbol name='cube' />,
                        children: [
                            {
                                id: MenuItemKey.Admin_AssetsAndProcesses_NodeHierarchy,
                                label: labels.Platform_Nodes_MenuTitle,
                                link: () => "/admin/nodes/tree-view",
                                permissions: localStorage.hasRight('ADMINPORTAL.AssetWorX+.Setup'),
                                children: [],
                                icon: <SerendieSymbol name='layer' />,
                            },
                            {
                                id: MenuItemKey.Admin_AssetsAndProcesses_VirtualTreeViews,
                                label: labels.Platform_VirtualTreeViews_MenuTitle,
                                link: () => "/admin/virtual-tree-views",
                                permissions: localStorage.hasRight('ADMINPORTAL.VirtualTreeviews.Setup'),
                                children: [],
                                icon: <CustomViewIcon />,
                            },
                        ]
                    },
                ]
            }
        ];
    }
}

export interface IMenuItem
{
    id: MenuItemKey;
    solutionId?: string;
    label: string;
    link: () => (string | null);
    permissions: boolean;
    icon: ReactElement | string;
    children: Array<IMenuItem>;
}
